import { useEffect, useState } from "react";
import PageHero from "../components/PageHero";
import { fetchTeachers } from "../lib/api";

export default function Insegnanti() {
  const [teachers, setTeachers] = useState([]);

  useEffect(() => {
    fetchTeachers().then(setTeachers).catch(() => {});
  }, []);

  return (
    <div data-testid="page-insegnanti">
      <PageHero
        eyebrow="Il Corpo Docente"
        title="Maestri,"
        italic="concertisti, pedagogisti."
        subtitle="Un collettivo di professionisti con esperienza concertistica internazionale e profonda vocazione didattica. Molti sono esaminatori Trinity College London."
      />

      <section className="py-24 px-6 md:px-12 lg:px-24 max-w-[1400px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-[#A3133A]/15 border border-[#A3133A]/15">
          {teachers.map((t) => (
            <article key={t.id} data-testid={`teacher-${t.id}`} className="bg-[#FBFBF9] p-0 group">
              <div className="aspect-[4/5] overflow-hidden bg-[#A3133A]/5">
                {t.foto ? (
                  <img
                    src={t.foto}
                    alt={t.nome}
                    className="w-full h-full object-cover grayscale hover:grayscale-0 group-hover:scale-105 transition-all duration-700"
                  />
                ) : (
                  <div className="w-full h-full bg-[#A3133A] grain flex items-center justify-center p-8" data-testid={`teacher-vacante-${t.id}`}>
                    <div className="text-center text-[#FBFBF9]">
                      <div className="font-serif-display text-5xl italic opacity-60 mb-4">?</div>
                      <div className="text-[10px] tracking-eyebrow opacity-80">{t.ruolo}</div>
                      <div className="font-serif-display text-2xl italic mt-2">Posizione vacante</div>
                    </div>
                  </div>
                )}
              </div>
              <div className="p-7">
                <div className="text-[10px] tracking-eyebrow text-[#A3133A] mb-2">{t.ruolo}</div>
                <h3 className="font-serif-display text-2xl text-[#1C1C1C] mb-3 leading-tight">{t.nome}</h3>
                <p className="text-sm text-[#5C5C5C] leading-relaxed">{t.bio}</p>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
